import { ObjectSchema, object, string } from "yup";

import { PostServiceApi2BackOfficeAddIndexApiArg } from "@/api/generatedApi";

export const createIndexRequestSchema = object({
  name: string().required("REQUIRED_FIELD"),
  dataCutOffDate: string()
    .nullable()
    .transform((value) => value || undefined),
}) as ObjectSchema<PostServiceApi2BackOfficeAddIndexApiArg>;
